<script setup>
</script>

<template>
    <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path d="M12 16L6 10H18L12 16Z"></path>
    </svg>
</template>